const files = import.meta.glob('./*.vue', { eager: true });

export default Object.keys(files).reduce((modules, file) => {
    const name = 'Icon' + file.replace(/(\.\/|\.vue)/g, '');
    return { ...modules, [name]: files[file].default };
}, {});
